import axios from "axios";
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function AddEqpSubCat(){
    const [cat, setCat] = useState([]);
    const [rows, setRows] = useState([]);
    const [cats,setCats] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [subCatData,setsubCatData]=useState({
        "cat":'',
        "subcat":'',
        "amount":'',
        "status":'',
        "addedby":'',
        "ip_add":''
    });

    const handleChange = (event) => {
        setsubCatData({
            ...subCatData,
            [event.target.name]:event.target.value
        });
    }

    const formSubmit = () =>{
        const _formData = new FormData();
        _formData.append('cat',subCatData.cat_id);
        _formData.append('subcat',subCatData.subcat);
        _formData.append('status','1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);
        try{
            axios.post(baseUrl+'eqp-subcat/', _formData, {
                headers : {
                    'content-type': 'multiple/form-data'
                }
            })
            .then(function (response) {
               if(response.status==200 || response.status==201){
                    Swal.fire({
                        title: 'Data has been updated',
                        icon: 'success',
                        timer:5000,
                        showConfirmButton: false
                    });
                     setTimeout(() => {
                  window.location.href = ('/add-eqp-subcat');
                }, 3000);
               }
            });
            }catch(error){
                console.log(error);
            }
        };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
      if (cat.length > 0) {
        setRows(cat);
      }
  }, [cat]);
  function fetchData() {
    setIsLoading(true);
    axios.get(`${baseUrl}eqp-subcat/`)
      .then(response => {
        setCat(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
      });
  }
    useEffect(() => {
        try{
            axios.get(baseUrl+'eqp-cat/')
            .then(function (response) {
                setCats(response.data);
            });
        }catch(error){
            console.log(error);
        }
        },[]);
    const handleDelete = (cat_id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-eqp-subcat/'+cat_id)
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                       setTimeout(() => {
                          window.location.href = ('/add-eqp-subcat');
                        }, 3000);
                    });
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }
  const columns = [
    { field: 'id', headerName: 'Id', width: 70 },
    {
      field: 'category',
      headerName: 'Category',
      width: 200,
      renderCell: (params) => {
        return params.row.cat.category;
      }
    },
    { field: 'subcat', headerName: 'Sub Category', width: 500 },
    { field: 'addedby', headerName: 'Added By', width: 120},
    { field: 'edit', headerName: 'Edit',
        renderCell: (params) => (
          <Link to={`/edit-eqp-subcat/${params.row.id}`} target="_blank" className="btn btn-warning">
            Edit
          </Link>
      ),
      width: 120 },
      { field: 'delete', headerName: 'Action',
        renderCell: (params) => (
          <button onClick={()=> handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
          <i className="fa-solid fa-trash-can"></i></button>
      ),
      width: 120 },

  ];

    return (
        <section className="container mt-4">
            <div className="row">

              <div className='col-md-9 col-12 mb-2'>
                <div className='card'>
                    <h4 className='card-header'>Add Equipment Sub Category</h4>
                    <div className='card-body'>
                        <form>
                          <div className="mb-3">
                            <label htmlFor="cat_id" className="form-label">Category</label>
                            <select name="cat_id" value={subCatData.cat_id} onChange={handleChange} className="form-control">
                               <option>Select Category</option>
                                {cats.map((category,index) => {return <option key={index} value={category.id}>{category.category}
                                </option>})}
                            </select>
                          </div>
                          <div className="mb-3">
                            <label htmlFor="category" className="form-label">Sub Category</label>
                            <input type="text" className="form-control" name="subcat" value={subCatData.subcat}
                            onChange={handleChange} id="subcat" />
                          </div>

                          <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                        </form>
                    </div>
                </div>
              </div>
            </div>


        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid className="mt-4"
            sx={{
              boxShadow: 4,
              border: 4,
              borderColor: 'primary.light',
              '& .MuiDataGrid-cell:hover': {
                color: 'primary.main',
              },
            }}
            pageSize={28}
            rows={rows}
            columns={columns}
            components={{
                Toolbar: GridToolbar,
             }}
            autoHeight
          />
          </div>

        </section>

)
}

export default AddEqpSubCat;